export default __webpack_public_path__ + "static/media/mom9.07649e41.png";